/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubReferralGraphStatusHistory { 
    referralStatus?: PcmsHubReferralGraphStatusHistory.ReferralStatusEnum;
    sourceId?: string;
    statusDate?: string;
}
export namespace PcmsHubReferralGraphStatusHistory {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


